/**
 * @desc: - Banner- 大小依赖父级，可按左右甜头切换，按圆点切换
 * @param  {[ARRAY]} ：list [banners list 数组 对象{path:"", href: ""}]
 * @author: vico
 */
import React from 'react';
import { LOTTERY_MENUS } from '../../constants/menus/lotteryMenus'

export default class FullScreenBanner extends React.Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    // 当前显示图片index
    this.state = {
      current: 0
    }
  }

  // 启动自动滚动定时器
  componentDidMount(){
    this.goPaly();
  }

  // 销毁自动滚动定时器
  componentWillUnmount(){
    clearInterval(this.autoPalyFlag)
  }

  // 切换当前显示图片index
  changeCurrentDisplay(index){
    if (index === 'prev') {
      // 上一个
      this.turn(-1);
    }
    if (index === 'next') {
      // 下一个
      this.turn(1);
    }
  }

  // 自动切换
  turn(n){
    var _n = this.state.current +n;
    if(_n<this.props.list.length  && _n>=0){
      this.setState({current:_n})
    }else{
      if(_n == -1){
        this.setState({current:this.props.list.length -1})
        return;
      }
      this.setState({current:0})
    }
  }

  // 开始自动轮播
  goPaly(){
    this.autoPalyFlag = setInterval(()=>{
      this.turn(1);
    },3500)
  }

  // 点击轮播图
  handleClick(link){
    const activityRex =/\.*\/activity\/.*/;
    const betRex = /\.*\/lottery\/.*/;
    // 活动链接
    if (activityRex.test(link) && !_.includes(link, '.html')) {
      const aid = _.last(_.split(link, '/'))
      return window.open('#/activity/' + aid,"_blank")
    }
    //打开众合之旅
    if (activityRex.test(link) && _.includes(link, '.html')) {
      return window.open(link,"_blank")
    }
    // 投注页
    if (betRex.test(link) && !_.includes(link, '.html')) {
      const flaglot = _.last(_.split(link, '/'));
      const lotterys = _.concat(..._.map(LOTTERY_MENUS, 'lotterys'));
      const _lottery = _.find(lotterys, {flaglot: flaglot});
      return window.open(_lottery.uri,"_blank");
    }
    // 其他页新窗口打开
    window.open(link,'_self');
  }

  // 鼠标移入小圆点事件
  mouseover(i){
    this.setState({current:i});
  }

  //暂停自动轮播
  pausePlay(){
    clearInterval(this.autoPalyFlag)
  }
  render() {
    const { list } = this.props;
    return (
          <div className={"banner-box " +  this.props.className} onMouseOver={this.pausePlay.bind(this)} onMouseOut={this.goPaly.bind(this)}>
            <ul className="banner_box">
              {
                list.map((item,i)=>{
                  return  <li key={i} 
                            className ={this.state.current == i?'cur':''}>
                            <a style={{backgroundImage:`url(${item.picture})`}} href={'https://hxpicture.luoyinghua.com/2024/07/17/huodong2500x1200.jpg'} className='pointer' title={item.title} target='_blank'/>
                          </li>
                })
              }
            </ul>
            <a href="javascript:;" className="rslides_nav rslides1_nav prev" onClick={this.changeCurrentDisplay.bind(this,"prev")}>&lt;</a>
            <a href="javascript:;" className="rslides_nav rslides1_nav next" onClick={this.changeCurrentDisplay.bind(this,"next")}>&gt;</a>
            <ul className="rslides_tabs rslides1_tabs">
              {
                list.map((item,i)=>{
                  return <li key={i} onMouseOver={this.mouseover.bind(this,i)} className ={this.state.current == i?'rslides_here':''}><a></a></li>
                })
              }
            </ul>
          </div>
         
    );
  }
}
